export default "__VITE_ASSET__C7TVU$Wf__"